module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nfl/icons_passing_yds/blue-3654d89152b366e9b444a03c395035c2.svg";